export const BINGO_30 = 'Bingo30Layout';
export const BINGO_40 = 'Bingo40Layout';
export const BINGO_60 = 'Bingo60Layout';
export const BINGO_80 = 'Bingo80Layout';
export const BINGO_90 = 'Bingo90Layout';
